module.exports = __webpack_public_path__ + "static/media/database.fa97b008.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/database.svg
// module id = 506
// module chunks = 98